
let KDWardrobePreviewRestraintsListI = 1;

let KDWardrobePreviewRestraintsList: Record<string, Record<string, NPCRestraint>> = {
	Latex: {
		OuterGag: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "LatexOTNGagHeavy",
		},
		HeavyBondage: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "LatexStraitjacket",
		},
		Heels: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "LatexBootsBallet",
		},
	},
	Leather: {
		OuterGag: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "HarnessPanelGag",
		},
		HeavyBondage: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "TrapArmbinder",
		},
		Heels: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "TrapBoots",
		},

	},
	Metal: {

		HeavyBondage: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "HeavyYoke",
		},
		AnkleCuffs: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "SteelAnkleCuffs",
		},
		ThighCuffs: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "SteelThighCuffs",
		},
		Wrists: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "SteelArmCuffs",
		},
	},
	Rope: {

		Secure: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "WeakMagicRopeCuffsAdv2",
		},
		HeavyBondage: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "StrongMagicRopeArmsBoxtie",
		},
		Wrists: {
			lock: "",
			id: KDWardrobePreviewRestraintsListI++,
			name: "MithrilRopeCuffsAdv",
		},
	},
}